import {Populator} from "./populator";
import {Notification} from "./notification";

export class NotificationQueryParams extends Populator {
    id?: number;
    params_key?: string;
    params_value?: string;
    notification?: Notification;
}
